import Glide from "@glidejs/glide/entry/entry-complete";

export default {
	init() {
		this.initSlider();
		this.initSkinTypeSelector();
		this.initRisks();
	},

	initSlider() {
		let nextPageLinks = document.querySelectorAll('.js-next-page');
		let prevPageLinks = document.querySelectorAll('.js-prev-page');
		let form = document.querySelector('.js-assessment');
		let error = document.querySelector('.js-assessment-error');

		setTimeout(() => {
			let formSlider = new Glide('.js-assessment',{
				type: 'slider',
				perView: 1,
				gap: 0,
				keyboard: false,
				dragThreshold: false,
				swipeThreshold: false,
				rewind: false
			} ).mount();

			nextPageLinks.forEach((nextPageLink) => {
				nextPageLink.addEventListener('click', (event) => {
					//Validate
					let valid = false;
					let step = nextPageLink.dataset.step;
					let errorMessage = '';

					switch (step) {
						case "1":
							//Validate birth date
							let dob = document.querySelector('.js-datetimepicker').value;

							if (dob != '') {
								valid = true;
							}
							else {
								errorMessage = 'Please enter your date of birth';
							}
							break;

						case "2":
							//Validate skin type
							let skinType = document.querySelector('.js-skin-input').value;

							if (skinType != '') {
								valid = true;
							}
							else {
								errorMessage = 'Please choose your skin type';
							}
							break;
					
						case "3":
							//Validate primary concern
							let primaryConcern = document.querySelectorAll('.js-main-concern:checked');
							
							if (primaryConcern.length > 0) {
								valid = true;
							}
							else {
								errorMessage = 'Please choose your primary concern';
							}
							break;

						case "4":
							//Validate risk
							let risk = document.querySelectorAll('.js-risk:checked');

							if (risk.length > 0) {
								valid = true;
							}
							else {
								errorMessage = 'Please choose your risk concern';
							}
							break;

						case "5":
							//Validate disclaimer
							let howDidYouHear = document.querySelector('.js-how-did-you-hear').value;
							let confirmAccurate = document.querySelector('.js-confirm-accurate').checked;
							let confirmProposal = document.querySelector('.js-confirm-proposal').checked;
							let acceptAssessment = document.querySelector('.js-accept-assessment').checked;
							let acceptTerms = document.querySelector('.js-accept-terms').checked;

							if (howDidYouHear == '' || !confirmAccurate || !confirmProposal || !acceptAssessment || !acceptTerms) {
								errorMessage = 'Please check all the terms and ensure you have selected how you heard about is';
							}
							else {
								valid = true;
								form.submit();
							}
							break;
					
						default:
							break;
					}
					
					if (valid) {
						//Remove old errors and go to next slide
						error.classList.remove('c-assessment-error--active');
						formSlider.go('>');
					}
					else {
						//Set error message and show error
						error.innerHTML = errorMessage;
						error.classList.add('c-assessment-error--active');
					}
					
					event.preventDefault();
				});
			});
	
			prevPageLinks.forEach((prevPageLink) => {
				prevPageLink.addEventListener('click', (event) => {
					error.classList.remove('c-assessment-error--active');
					formSlider.go('<');
					event.preventDefault();
				});
			});
		}, 1);
		
		
	},

	initSkinTypeSelector() {
		let selectors = document.querySelectorAll('.js-skin-type-selector');
		let mobileTypeTips = document.querySelectorAll('.c-skintype_select__tooltip--mobile')

		selectors.forEach((selector) => {
			selector.addEventListener('click', (event) => {
				let skinType = selector.dataset.skinType;
				let skinInput = document.querySelector('.js-skin-input');
				let mobileTipTarget = document.querySelector('.c-skintype_select__tooltip--' + skinType);

				selectors.forEach((innerSelector) => {
					innerSelector.classList.remove('c-skintype_select__option--active');
				});

				//Handle show / hide of mobile tips
				mobileTypeTips.forEach((mobileTypeTip) => {
					mobileTypeTip.classList.remove('c-skintype_select__tooltip--active');
				});
				mobileTipTarget.classList.add('c-skintype_select__tooltip--active');

				selector.classList.add('c-skintype_select__option--active');

				skinInput.value = skinType;
			});
		});
	},

	initRisks() {
		let noneSelected = document.querySelector('.js-none');
		let riskOptions = document.querySelectorAll('.js-risk-option');

		//Uncheck none of the above if a regular option is selected
		riskOptions.forEach((riskOption) => {
			riskOption.addEventListener('change', (even) => {
				if (event.target.checked) {
					noneSelected.checked = false;
				}
			});
		});
		
		noneSelected.addEventListener('change', (event) => {
			if (event.target.checked) {
				riskOptions.forEach((riskOption) => {
					riskOption.checked = false;
				});
			}
		});
	}
}